import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { NavLink } from 'react-router-dom';
import TimeAgo from 'timeago-react';
import { GlobalUncContext } from '../../../Components/Layout/Layout';
import useClickOutside from '../../../Hooks/useClickOutside';
import { dicoverTopCollections, dicoverTopSallerInDayData } from '../../../Shared/DiscoverPageFakeData';
import { discoverNFTData } from '../../../Shared/FackeDataFactory';
import { overviewRecentActivityData } from '../../../Shared/ProfilePageFakeData';

import './ProfileOverview.scss';
export interface IOverviewLeftSideProps {
}

export function OverviewLeftSide(props: IOverviewLeftSideProps) {
    const { setRecentActOpen } = React.useContext(GlobalUncContext)

    const [recentActivityDropOpen, setRecentActivityDropOpen] = React.useState(false)
    const [recentActivityDropText, setRecentActivityDropText] = React.useState('Likes');
    let recentActivityRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(recentActivityRef, () => setRecentActivityDropOpen(false))


    // for Day Dropdown
    const [dayDropdownOpen, setdayDropdownOpen] = React.useState(false)
    const [dayText, setDayText] = React.useState('1 Day');
    let dayTextBodyRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(dayTextBodyRef, () => setdayDropdownOpen(false))

    // top Seller dropdown
    const [topSellerDropOpen, setTopSellerDropOpen] = React.useState(false)
    const [topSellerDropText, settopSellerDropText] = React.useState('Seller');
    let topSellerDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(topSellerDropRef, () => setTopSellerDropOpen(false))


    // for second Day Dropdown
    const [topInDropOpen, setTopInDropOpen] = React.useState(false)
    const [topInDropText, setTopInDropText] = React.useState('1 Day');
    let topInDropRef = React.useRef<HTMLHeadingElement>(null)
    useClickOutside(topInDropRef, () => setTopInDropOpen(false))



    return (
        <div className="text-left lg:w-11/12 xl:w-full">
            <div className="text-left">
                <div className="inline-block relative">
                    <h1 className="xs:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">About</h1>
                    <div className="bottom-1 absolute -right-4">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                    <stop offset={0} stopColor="#00dbff" />
                                    <stop offset="0.529" stopColor="#e315e8" />
                                    <stop offset={1} stopColor="#ffd817" />
                                </linearGradient>
                            </defs>
                            <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                        </svg>
                    </div>
                </div>

                <p className="text-sm xl:text-base text-l-LightBlack dark:text-cusBlueWhite mt-4">Hi there, <br />
                    Welcome to the official collection page for Donald Trump. To join the Donald Trump you can mint your own Donald Trump NFT for 0.05 ETH from the official mint page
                    <br />
                    <br />

                    💪Make Sure you are one of the owners in the first wave💪</p>
            </div>




            <div className="mt-14 xl:mt-20">
                <div className="flex justify-between items-center">
                    <div className="flex justify-start items-center">
                        <h1 className="text-base xxsm:text-xl sm:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Recent Activity</h1>

                        <div ref={recentActivityRef} className="cursor-pointer relative w-full text-left flex-1 max-w-[250px]"
                            onClick={() => setRecentActivityDropOpen(!recentActivityDropOpen)}>

                            <div className="flex justify-between items-center break-all">
                                <h4 className="text-[#6F6DAB] font-bold text-sm xxsm:text-lg sm:text-2xl xl:text-3xl 
                                mr-3 whitespace-nowrap overflow-ellipsis overflow-hidden">{recentActivityDropText}</h4>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className={`h-4 w-4 transition-all ${recentActivityDropOpen && 'rotate-180'}`}
                                        fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                            </div>

                            <AnimatePresence>
                                {recentActivityDropOpen &&
                                    <motion.div
                                        animate={recentActivityDropOpen ? "open" : "closed"}
                                        initial={{ y: -15, }}
                                        variants={{
                                            open: { y: 0, },
                                            closed: { y: -100, },
                                        }}
                                        exit={{ opacity: 0, y: -15 }}
                                        transition={{ duration: 0.2 }}
                                        className="rounded-xl overflow-hidden absolute top-9 xl:top-11 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20
                                                        min-w-[120px] sm:min-w-[150px]">
                                        {['Likes', 'Comments', 'Shares',].map(item =>
                                            <div onClick={() => { setRecentActivityDropText(item) }}
                                                className={`py-3 px-4 hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base 
                                                        font-medium whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                            </div>
                                        )}

                                    </motion.div>}
                            </AnimatePresence>
                        </div>
                    </div>
                    <button
                        onClick={() => setRecentActOpen(true)}
                        className="xs:text-xxs sm:text-base text-cusBlack dark:text-white">See all &gt;</button>
                </div>


                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-x-5 gap-y-5 mt-5">
                    {overviewRecentActivityData.map(activity =>
                        <div className="flex justify-start items-center lightBlueBg p-4 rounded-lg" key={activity.id}>
                            <div>
                                <div className="xs:w-8 xs:h-8 sm:w-10 sm:h-10 lg:h-12 lg:w-12 rounded-full">
                                    <img src={activity.logo} alt="" className="w-full h-full" />
                                </div>
                            </div>

                            <div className="ml-5 text-left">
                                <h4 className="xs:text-xs sm:text-sm 2xl:text-base text-cusBlack dark:text-white break-words">{activity.eventText}</h4>
                                <TimeAgo
                                    className="text-cusBlack dark:text-cusBlueWhite text-xs time_ago_text"
                                    datetime={activity.time}
                                    locale='en_US'
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>



            <div className="mt-8">
                <div className="relative inline-block">
                    <h1 className="xs:text-xl sm:text-2xl xl:text-3xl mr-3 dark:font-bold font-black text-cusBlack dark:text-white">Top nft's</h1>

                    <div className="bottom-1 absolute -right-2">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                    <stop offset={0} stopColor="#00dbff" />
                                    <stop offset="0.529" stopColor="#e315e8" />
                                    <stop offset={1} stopColor="#ffd817" />
                                </linearGradient>
                            </defs>
                            <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                        </svg>
                    </div>
                </div>


                <ScrollContainer
                    nativeMobileScroll={true}
                    horizontal={true}
                    className="scroll-container mb-8 xs:mt-3 md:mt-4 flex xs:space-x-3 sm:space-x-5 xl:space-x-3 2xl:space-x-5 overflow-auto ">
                    {discoverNFTData.slice(0, 4).map((data, index) =>
                        <div key={data.id}>
                            <div className="xs:w-36 sm:w-44 xl:w-full">
                                <img src={data.thumImage} alt="" className="w-full" />
                            </div>
                            <div className="mt-4 flex justify-start items-center">
                                <div className="nft_profile_pic rounded-full flex justify-center items-center">
                                    <div className="rounded-full">
                                        <img src={data.photo} alt="" className="w-full h-full" />
                                    </div>
                                </div>
                                <div className="xs:ml-3 xl:ml-2 2xl:ml-3 text-left">
                                    <h4 className="xs:text-sm sm:text-base xl:text-xs 2xl:text-sm 3xl:text-base text-cusBlack dark:text-white">{data.name}</h4>
                                    <p className="text-sm text-cusBlack dark:text-cusBlueWhite">${data.price.toLocaleString()}</p>
                                </div>
                            </div>
                        </div>
                    )}
                </ScrollContainer>
            </div>






            <div className="mt-14">

                <div className="flex justify-between items-center">
                    <div className="flex justify-start items-center">
                        <h1 className="xs:text-lg sm:text-xl xl:text-3xl mr-3 font-bold text-cusBlack dark:text-white">Top collections in</h1>

                        <div ref={dayTextBodyRef} className="cursor-pointer relative w-full text-left flex-1 max-w-[250px]"
                            onClick={() => setdayDropdownOpen(!dayDropdownOpen)}>

                            <div className="flex justify-between items-center break-all">
                                <h4 className="text-[#6F6DAB] font-bold text-sm xxsm:text-lg sm:text-2xl xl:text-3xl 
                                mr-3 whitespace-nowrap overflow-ellipsis overflow-hidden">{dayText}</h4>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className={`h-4 w-4 transition-all ${dayDropdownOpen && 'rotate-180'}`}
                                        fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                            </div>

                            <AnimatePresence>
                                {dayDropdownOpen &&
                                    <motion.div
                                        animate={dayDropdownOpen ? "open" : "closed"}
                                        initial={{ y: -15, }}
                                        variants={{
                                            open: { y: 0, },
                                            closed: { y: -100, },
                                        }}
                                        exit={{ opacity: 0, y: -15 }}
                                        transition={{ duration: 0.2 }}
                                        className="rounded-xl overflow-hidden absolute top-9 xl:top-11 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20
                                                        min-w-[120px] sm:min-w-[150px]">
                                        {['1 Day', '2 Day', '3 Day', '4 Day',].map(item =>
                                            <div onClick={() => { setDayText(item) }}
                                                className={`py-3 px-4 hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base 
                                                        font-medium whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                            </div>
                                        )}

                                    </motion.div>}
                            </AnimatePresence>
                        </div>
                    </div>
                    <NavLink to="/explore" className="xs:text-xxs sm:text-base text-cusBlack dark:text-white">See all &gt;</NavLink>
                </div>


                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-x-5 gap-y-7">
                    {dicoverTopCollections.map((topColl, index) =>
                        <div className="top_collections_item p-4 rounded-xl flex justify-between items-center" key={topColl.id}>
                            <div className="flex justify-start items-center">
                                <p className="text-cusBlack dark:text-cusBlueWhite text-base">{index + 1}</p>
                                <div className="w-14 h-14 rounded-full xs:ml-2 3xl:ml-3">
                                    <img src={topColl.logo} alt="" />
                                </div>
                                <div className="xs:ml-2 3xl:ml-4 text-left">
                                    <h4 className="text-base text-cusBlack font-semibold dark:font-normal dark:text-white">{topColl.name}</h4>
                                    <div className="flex justify-start items-center mt-2">
                                        <p className="text-cusBlack dark:text-cusBlueWhite text-xs">Floor Price</p>
                                        <div className="ml-5">
                                            <svg className="w-[8px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                                <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                                <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                                <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                                <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                                <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                            </svg>

                                        </div>
                                        <p className="text-cusBlack dark:text-cusBlueWhite text-xs ml-2">{topColl.floorPrice}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="">
                                <div className="px-4 py-1 rounded-md fle"
                                    style={topColl.rankRate ?
                                        topColl.rankRate < 0
                                            ? { backgroundColor: 'var(--nagativeCollectionMark)', border: '1px solid #FF0000' }
                                            : { backgroundColor: 'var(--positiveCollectionsMark)', border: '1px solid #21BF80' }
                                        : { backgroundColor: 'var(--nullCollectionsMark)', border: '1px solid #3C3980' }}>
                                    <p className="text-white text-xs">{topColl.rankRate ? topColl.rankRate + "%" : "--"}</p>
                                </div>
                                <div className="flex justify-end items-center mt-2">
                                    <svg className="w-[8px]" viewBox="0 0 256 417" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid">
                                        <path className="fill-[#343434] dark:fill-[#FFFFFF60]" fill="" d="M127.961 0l-2.795 9.5v275.668l2.795 2.79 127.962-75.638z" />
                                        <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 0L0 212.32l127.962 75.639V154.158z" />
                                        <path className="fill-[#3C3C3B] dark:fill-[#FFFFFF60]" fill="" d="M127.961 312.187l-1.575 1.92v98.199l1.575 4.6L256 236.587z" />
                                        <path className="fill-[#8C8C8C] dark:fill-[#FFFFFF]" fill="" d="M127.962 416.905v-104.72L0 236.585z" />
                                        <path className="fill-[#141414] dark:fill-[#FFFFFF20]" fill="" d="M127.961 287.958l127.96-75.637-127.96-58.162z" />
                                        <path className="fill-[#393939] dark:fill-[#FFFFFF60]" fill="" d="M0 212.32l127.96 75.638v-133.8z" />
                                    </svg>

                                    <p className="text-cusBlack dark:text-cusBlueWhite text-xs ml-2">{topColl.floorPrice2.toLocaleString()}</p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>


            <div className="mt-14">
                <div className="flex justify-between items-center">
                    <div className="flex justify-start items-center">
                        <h1 className="xs:text-lg sm:text-2xl xl:text-3xl mr-2 font-bold text-cusBlack dark:text-white">Top</h1>

                        <div ref={topSellerDropRef} className="cursor-pointer relative w-full text-left grow max-w-[250px]"
                            onClick={() => setTopSellerDropOpen(!topSellerDropOpen)}>

                            <div className="flex justify-between items-center break-all">
                                <h4 className="text-[#6F6DAB] font-bold text-sm xxsm:text-lg sm:text-2xl xl:text-3xl 
                                        mr-3 whitespace-nowrap overflow-ellipsis overflow-hidden">{topSellerDropText}</h4>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className={`h-4 w-4 transition-all ${topSellerDropOpen && 'rotate-180'}`}
                                        fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                            </div>

                            <AnimatePresence>
                                {topSellerDropOpen &&
                                    <motion.div
                                        animate={topSellerDropOpen ? "open" : "closed"}
                                        initial={{ y: -15, }}
                                        variants={{
                                            open: { y: 0, },
                                            closed: { y: -100, },
                                        }}
                                        exit={{ opacity: 0, y: -15 }}
                                        transition={{ duration: 0.2 }}
                                        className="rounded-xl overflow-hidden absolute top-9 xl:top-11 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20
                                                        min-w-[120px] sm:min-w-[150px]">
                                        {['Seller', 'Buyer',].map(item =>
                                            <div onClick={() => { settopSellerDropText(item) }}
                                                className={`py-3 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium
                                                        whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                            </div>
                                        )}
                                    </motion.div>}
                            </AnimatePresence>
                        </div>


                        <h1 className="xs:text-lg grow-0 sm:text-2xl xl:text-3xl mr-2 ml-3 font-bold text-cusBlack dark:text-white">in</h1>


                        <div ref={topInDropRef} className="cursor-pointer relative w-full text-left grow max-w-[250px]"
                            onClick={() => setTopInDropOpen(!topInDropOpen)}>

                            <div className="flex justify-between items-center break-all">
                                <h4 className="text-[#6F6DAB] font-bold text-sm xxsm:text-lg sm:text-2xl xl:text-3xl 
                                        mr-3 whitespace-nowrap overflow-ellipsis overflow-hidden">{topInDropText}</h4>
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg"
                                        className={`h-4 w-4 transition-all ${topInDropOpen && 'rotate-180'}`}
                                        fill="none" viewBox="0 0 24 24" stroke="#6F6DAB" strokeWidth={5}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                                    </svg>
                                </div>
                            </div>

                            <AnimatePresence>
                                {topInDropOpen &&
                                    <motion.div
                                        animate={topInDropOpen ? "open" : "closed"}
                                        initial={{ y: -15, }}
                                        variants={{
                                            open: { y: 0, },
                                            closed: { y: -100, },
                                        }}
                                        exit={{ opacity: 0, y: -15 }}
                                        transition={{ duration: 0.2 }}
                                        className="rounded-xl overflow-hidden absolute top-9 xl:top-11 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20
                                                        min-w-[120px] sm:min-w-[150px]">
                                        {['1 Day', '2 Day', '3 Day', '4 Day',].map(item =>
                                            <div onClick={() => { setTopInDropText(item) }}
                                                className={`py-3 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                                <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium
                                                        whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                            </div>
                                        )}
                                    </motion.div>}
                            </AnimatePresence>
                        </div>

                    </div>
                    <NavLink to="/explore" className="xs:text-xxs sm:text-base text-cusBlack dark:text-white">See all &gt;</NavLink>
                </div>

                <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-x-4 gap-y-4">
                    {dicoverTopSallerInDayData.map((data, index) =>
                        <div className="top_collections_item p-4 rounded-xl flex justify-between items-center" key={data.id}>
                            <div className="flex justify-start items-center">
                                <p className="text-cusBlack dark:text-cusBlueWhite text-base">{index + 1}</p>
                                <div className="w-14 h-14 rounded-full xs:ml-2 3xl:ml-3">
                                    <img src={data.logo} alt="" />
                                </div>

                                <div className="xs:ml-3 3xl:ml-4 text-left">
                                    <div className="break-all">
                                        <h4 className="text-sm xl:text-xs 2xl:text-sm text-cusBlack font-semibold dark:font-normal dark:text-white break-words">{data.userName}</h4>
                                    </div>
                                    <div className="flex justify-start items-center mt-2">
                                        <p className="text-cusBlack dark:text-cusBlueWhite text-xs ">${data.price.toLocaleString()}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>













        </div>
    );
}
